export default "__VITE_ASSET__DUGB142p__"